export default {
  rewriteRoute: {
    beforeEnter: (to, from, next) => {
      to.meta.from = from.name
      to.meta.to = to.name
      next()
    }
  }
}
